module.exports = __webpack_public_path__ + "media/yi3.659c9b93.mp4";